import {Component, OnInit} from '@angular/core';
import {Media} from "../../../models/media";
import {Structure} from "../../../models/structure";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ProjectService} from "../../../services/project/project.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CustomValidators} from "../../../calsses/CustomValidators";
import {MediaService} from "../../../services/media/media.service";
import {forkJoin} from "rxjs";
import {DatabaseService} from "../../../services/database/database.service";
import {MessagesService} from "../../../services/messages/messages.service";

@Component({
  selector: 'app-edit-structure',
  templateUrl: './edit-structure.component.html',
  styleUrls: ['./edit-structure.component.scss']
})
export class EditStructureComponent implements OnInit {

  structure: Structure;
  projectId: string;
  databaseId: string;
  mediaImages: Array<Media>;
  code: string;

  structureForm: FormGroup;
  structureFormIsSubmitted: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private mediaService: MediaService,
    private projectService: ProjectService,
    private messagesService: MessagesService,
    private databaseService: DatabaseService
  ) {
  }

  ngOnInit() {
    this.code = this.route.snapshot.queryParams.c;

    this.route.parent.params.subscribe(
      params => {
        this.projectId = params['project_id'];
        this.databaseId = params['database_id'];

        // forkJoin(
        //   this.mediaService.getAllMyMedia(this.databaseId, this.databaseService.getDatabaseLang(), MediaService.IMAGE_TYPE),
        //   this.databaseService.getSingleDatabase(this.projectId, this.databaseId)
        // ).subscribe(
        this.mediaService.getAllMyMedia(this.projectId, null, MediaService.IMAGE_TYPE)
          .subscribe(
          () => {
            this.mediaImages = this.mediaService.mediaImages;
            this.structure = this.databaseService.database.structure;

            this.structureForm = this.formBuilder.group({
              logo: [this.structure.logo || ''],
              name: [this.structure.name || '', [Validators.required]],
              image: [this.structure.image || ''],
              ticket: [isNaN(this.structure.ticket) ? '' : this.structure.ticket, [CustomValidators.priceValidator()]],
              description: [this.structure.description || ''],
            });
          },
          err => this.messagesService.errorToast(err)
        );
      },
      err => this.messagesService.errorToast(err)
    );
  }

  onSubmit() {
    this.structureFormIsSubmitted = true;

    if (this.structureForm.invalid) {
      return;
    }

    const structure = new Structure(this.structureForm.getRawValue());

    this.databaseService.patchStructure(this.projectId, this.databaseId, structure)
      .subscribe(
        () => {
          this.messagesService.successModal('Structure updated!', 'Done');
          this.router.navigate(['/projects/' + this.projectId +'/databases/' + this.databaseId])
            .catch(err => this.messagesService.errorToast(err));
        },
        err => this.messagesService.errorToast(err)
      );
  }

  onSelectImage(media: Media) {
    this.structureForm.patchValue({
      image: media._id
    });
  }

  onSelectLogo(media: Media) {
    this.structureForm.patchValue({
      logo: media._id
    });
  }

  onRemoveImage(media: Media) {
    this.structureForm.patchValue({
      image: null
    });
  }

  onRemoveLogo(media: Media) {
    this.structureForm.patchValue({
      logo: null
    });
  }
}
